<template>
  <div class="nlp__header-box">
    <div
      class="nlp__header-logo"
      @click="nlpScrollToTop"
    >
      <NlpLogo v-if="!isNlpMobile" />
      <NlpLogoMobile v-else />
    </div>
    <div
      v-if="!isNlpMobile"
      class="nlp__header-menu"
    >
      <div
        class="nlp__header-menu-item"
        :class="{ 'nlp__header-menu-item--active': getActiveHeaderSection === 'risks' }"
        @click="nlpScrollToViewSelector('.nlp__why-check', -128)"
      >
        Risks
      </div>
      <div
        class="nlp__header-menu-item"
        :class="{ 'nlp__header-menu-item--active': getActiveHeaderSection === 'solutions' }"
        @click="nlpScrollToViewSelector('.nlp__why-satoshi', -128)"
      >
        Solutions
      </div>
      <div
        class="nlp__header-menu-item"
        :class="{ 'nlp__header-menu-item--active': getActiveHeaderSection === 'pricing' }"
        @click="onPricingClick"
      >
        Pricing
      </div>
      <div
        class="nlp__header-menu-item"
        :class="{ 'nlp__header-menu-item--active': getActiveHeaderSection === 'faq' }"
        @click="nlpScrollToViewSelector('.nlp__faq', -128)"
      >
        FAQ
      </div>
    </div>
    <div class="nlp__header-buttons">
      <NlpButton
        :primary-small="isScrolled"
        :tertiary="!isScrolled"
        text="Get Started"
        @button-click="$router.push({ name: 'source-of-funds' })"
      />
      <NlpBurger v-if="isNlpMobile" />
    </div>
  </div>
</template>

<script>
// Components
import NlpLogo from '@/pages/landing-page/svg/NlpLogo.vue'
import NlpLogoMobile from '@/pages/landing-page/svg/NlpLogoMobile.vue'
import NlpButton from '@/pages/landing-page/ui-components/NlpButton.vue'
import NlpBurger from '@/pages/landing-page/ui-components/NlpBurger.vue'

// Mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

// Utils
import { nlpScrollToViewSelector, nlpScrollToTop } from '@/utils/scroll-to'

// Vuex
import { mapGetters } from 'vuex'

export default {
  name: 'NlpHeader',
  components: {
    NlpLogo,
    NlpButton,
    NlpLogoMobile,
    NlpBurger,
  },
  mixins: [deviceWidthMixin],
  props: {
    isScrolled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getActiveHeaderSection: 'nlp/getActiveHeaderSection',
      isLogin: 'user/isLogin',
      getCurrentPlan: 'payment/getCurrentPlan',
    }),
    shouldRedirectPricingToChangePlan() {
      if (this.isLogin) return true
      const plan = this.getCurrentPlan
      return plan && plan.planTier !== 'free'
    },
  },
  methods: {
    nlpScrollToViewSelector,
    nlpScrollToTop,
    onPricingClick() {
      if (this.shouldRedirectPricingToChangePlan) {
        this.$router.push({ name: 'changePlan' })
      } else {
        this.nlpScrollToViewSelector('.nlp__pricing', -128)
      }
    },
  },
}
</script>

<style scoped>
/* box */
.nlp__header-box {
  display: flex;
  align-items: center;
  height: 72px;
  padding: 0 16px;
  background-color: #fff;
  border: 1px solid #E2E9F6;
  border-radius: 24px;
  position: relative;
  z-index: 5;
}

/* logo */
.nlp__header-logo {
  flex: 1;
  cursor: pointer;
}

/* menu */
.nlp__header-menu {
  display: flex;
  align-items: center;
  gap: 32px;
}
.nlp__header-menu-item {
  padding: 4px;
  font-weight: 500;
  font-size: 14px;
  line-height: 1;
  color: #5A627D;
  transition: color 0.3s ease;
  cursor: pointer;
}
.nlp__header-menu-item:hover,
.nlp__header-menu-item--active {
  color: #194BFB;
}

/* buttons */
.nlp__header-buttons {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

@media (max-width: 767px) {
  .nlp__header-box {
    border: none;
    border-bottom: 1px solid #E2E9F6;
    border-radius: 0;
  }
  .nlp__header-logo {
    flex: 0;
  }
}
</style>
